import React, { useEffect, useState } from "react";
import Api from "services/api";
import AppointmentDetailsTable from "components/AppointmentDetailsTable";
import { Link, useLocation } from "react-router-dom";
import { SubmitButton } from "components/common/buttons/SubmitButton";
// import { setRequesterIframeUrl } from "slices/requesterIframeUrlSlice";
import toast from "react-hot-toast";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Video } from "lucide-react";

const AppointmentDetails = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [data, setData] = useState();
  const [statusMessage, setStatusMessage] = useState();
  const [status, setStatus] = useState();
  const [recordingUrl, setRecordingUrl] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleGetAppointmentDetail = async () => {
      try {
        const response = await Api.getAppointmentDetail(token);
        if (response.data.message === "Data retrieved successfully.") {
          console.log("res", response?.data);
          setData(response?.data?.data);
          setStatusMessage(response?.data?.message);
          setStatus(response?.data?.success);
        } else {
          console.error(
            "Failed to join:",
            response?.data?.message || "Unknown error"
          );
        }
      } catch (err) {
        console.error("Error joining video call:", err);
      }
    };
    handleGetAppointmentDetail();
  }, [token]);

  //   Join Video Call handler for Requester
  const handleJoinVideoCall = async () => {
    // window.open(`/appointment-details/view/requester/join-room-call`, "_blank");
    window.open(`/appointment-details/view/requester/join-room-call?token=${token}`, "_blank");
  };

  // const handleJoinVideoCall = async () => {
  //   try {
  //     const response = await Api.requesterJoinRoom(token);
  //     if (response?.status === 200) {
  //       const iframeUrl = response?.data?.data?.iframe_url;
  //       dispatch(setRequesterIframeUrl(iframeUrl));
  //       window.open(
  //         `/appointment-details/view/requester/join-room-call`,
  //         "_blank"
  //       );
  //       console.log("Joined successfully:", response?.data?.data?.iframe_url);
  //     } else {
  //       const errorMsg =
  //         response?.data?.statusText ||
  //         response?.data?.message ||
  //         response?.data?.error;
  //       console.error("Failed to join:", errorMsg);
  //       toast.error(errorMsg, { className: "errorToast" });
  //     }
  //   } catch (err) {
  //     console.error("Error joining video call:", err);
  //   }
  // };

  const showRecordingPopup = () => {
    if (data?.appointment_details?.recording) {
      setRecordingUrl(data.appointment_details.recording);
      setShowModal(true);
    } else {
      toast.error("Recording not available for this appointment.", {
        className: "errorToast",
      });
    }
  };

  return (
    <>
      {statusMessage === "Data retrieved successfully." && data ? (
        <div className="main-resPage w-[100%]" style={{ width: "100%" }}>
          <img src="/images/logo-fill.png" alt="" />
          <div style={{ width: "100%" }} className="table_wrapper">
            <div className="row_main_head bg-primary-secondaryCard">
              <h2 className={`main_heading main_heading1 mb-2`}>
                Appointment # {data?.appid}
              </h2>
              {status && (
                <span className="main_heading main_heading1">
                  Status: {data?.status}
                </span>
              )}
            </div>
            <div className="row_main_head bg-light-secondaryCard mt-3 d-flex flex-wrap">
              <h2 className={`main_heading2 d-flex mb-2`} toLowerCase={"text-lowercase"}>
                <span>Date & Time</span>
                <span className="dateTime">
                  {data?.date
                    ? new Date(data.datetime).toLocaleString()
                    : "N/A"}
                </span>
              </h2>
              <div className="mb-3">
                <div className="text-transform-capitalize main_heading2">
                  <span className="appLanguage">{data?.language?.name}</span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-between px-2 align-items-center mt-4">
              {data.type === "VRI" && (
                <SubmitButton
                  className="green"
                  btnText="Join Video Call"
                  icon={<Video />}
                  handleSubmit={handleJoinVideoCall}
                />
              )}
              {/* View Recording Button  */}
              {data?.appointment_details?.recording && (
                <SubmitButton
                  className="Cancle_button"
                  btnText="View Recording"
                  handleSubmit={showRecordingPopup}
                />
              )}
            </div>
            <div style={{ width: "100%" }} className="px-2">
              <AppointmentDetailsTable item={data} />
            </div>
          </div>
        </div>
      ) : statusMessage === "Page Expired" ? (
        <div className="error-page-container">
          <img src="/images/logo-fill.png" alt="" />
          <h4>OOps! {statusMessage}</h4>
          <Link to="/" className="main_button mt-5">
            Go to home page
          </Link>
        </div>
      ) : (
        <div className="error-page-container">
          <img src="/images/logo-fill.png" alt="" />
          <h4>Oopps! The page you were looking for doesn't exist.</h4>
          <p>
            <Link to="/" className="button">
              Go to home page
            </Link>
          </p>
        </div>
      )}

      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default AppointmentDetails;
